<template>
    <DialogRoot>
        <DialogTrigger>
            <button class="px-6 py-3 rounded-xl text-white bg-[#3c41e9]">Voir les détails</button>
        </DialogTrigger>
        <DialogPortal>
            <DialogOverlay className="fixed z-[1000] inset-0 bg-[#00000044] data-[state=open]:animate-overlayShow"/>
            <DialogContent className="fixed text-black p-0 overflow-hidden w-[50%] h-[90vh] z-[1001] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-xl bg-white shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] focus:outline-none data-[state=open]:animate-contentShow">
                <div class="h-full flex flex-col">
                    <div class="font-light border-b p-[16px] w-full flex items-center justify-between">
                        <h2>Détails requêtes</h2>
                        <DialogClose><X class="cursor-pointer" :size="16" strokeWidth="1.3"/></DialogClose>
                    </div>
                    <div class="grow w-full p-[16px] flex flex-col gap-y-[16px] overflow-y-scroll">
                        <div class="p-[8px] border rounded-xl w-full">
                            <div class="flex items-center justify-between mb-[8px]">
                                <div class="flex items-center gap-x-[12px]">
                                    <div class="size-[45px] rounded-full bg-[#3474f4] text-white text-[15px] font-bold flex items-center justify-center">
                                        {{ request.exception.user.first_name.charAt(0).toUpperCase() }}
                                    </div>
                                    <div class="flex flex-col items-start">
                                        <span class="text-[12px]">{{ request.exception.user.first_name + " " + request.exception.user.last_name }}</span>
                                        <span class="underline font-extralight text-[11px]">{{ request.exception.user.email }}</span>
                                    </div>
                                </div>
                                <div class="h-full flex flex-col items-end justify-between">
                                    <span class="font-light text-[13px]"><span class="underline">Période</span> : {{ formatDate2(`${request.exception.date_start}T${request.exception.date_end}`) }}</span>
                                    <!-- <span :class="['px-4 py-1 text-[13px] inline-flex items-center gap-x-[6px] rounded-xl',{'text-[#099556] bg-[#0995562e]':Number(request.exception.is_perm) == 1,'text-[#fa9832] bg-[#fa993231]':Number(request.exception.is_perm) == 0}]">
                                        <div :class="['size-[8px] rounded-full',{'bg-[#099556]':Number(request.exception.is_perm) == 1,'bg-[#fa9832]':Number(request.exception.is_perm) == 0}]"/>
                                        {{ request.motif.text }}
                                    </span> -->
                                </div>
                            </div>
                            <p class="text-[13px] px-3 py-1 rounded-lg font-light bg-[#d7e6fe] text-[#1e265c]">
                                <span class="underline">Détails :</span> Aucune justification n'a été fournie.
                            </p>
                        </div>
                        <div class="grow w-full">
                            <div class="flex items-center font-extralight gap-x-[16px] mb-[16px]">
                                <div class="flex items-center gap-x-[16px]"><Info :size="16" strokeWidth="1.2" /> Flow de validation de la requête</div>
                                <span class="px-3 text-[12px] py-1 rounded-lg bg-[#fcdfc0] text-[#442511] flex items-center gap-x-[8px]"><Loader :size="16" strokeWidth="1.2" class="animate-spin"/>  En cours</span>
                            </div>

                            <div class="mb-[16px] relative">
                                <div class="absolute h-full w-[12.5px] left-0 top-0 border-r z-[-1] border-dashed"/>
                                <div class="flex items-center gap-x-[16px]">
                                    <div class="flex items-center justify-center bg-[#f8f8f8] size-[25px] rounded-full">
                                        <Plus color="#6b6f70" :size="16" strokeWidth="1.5"/>
                                    </div>
                                    <p class="font-light">Demande de <span class="lowercase">{{ request.motif.text }}</span> par {{ request.exception.user.first_name + " " + request.exception.user.last_name }}</p>
                                </div>
                                <div class="pl-[41px]"><span class="font-extralight text-[13px]">Le {{ formatDate(request.created_at.split('T')[0]) }}</span></div>
                            </div>

                            <div class="relative mb-[16px]">
                                <div class="absolute h-full w-[12.5px] left-0 top-0 border-r z-[-1] border-r-[#0c5ccf]"/>
                                <div class="flex items-center gap-x-[16px]">
                                    <div class="flex items-center border-[3px] border-white justify-center bg-[#0c5ccf] size-[25px] rounded-full">
                                        <Check color="#ffffff" :size="16" strokeWidth="1.5"/>
                                    </div>
                                    <p class="font-light"><span class="text-[#0c5ccf]">Valider par</span> Djédjé Junior <span class="font-extralight">( écrire à: <a href="mailto:junior.djedje@lce-ci.com">junior.djedje@lce-ci.com</a> )</span></p>
                                </div>
                                <div class="pl-[41px]"><span class="font-extralight text-[13px]">Le {{ formatDate(request.created_at.split('T')[0]) }}</span></div>
                            </div>
                            <!-- <div class="size-[25px] rounded-full bg-[#0c5ccf]"></div> -->

                            <div class="mb-[16px]">
                                <div class="flex items-center gap-x-[16px]">
                                    <div class="flex items-center text-[#6b6f70] justify-center bg-[#f8f8f8] size-[25px] rounded-full">
                                        <span class="font-extralight">2</span>
                                    </div>
                                    <p class="font-light"><span class="text-[#c97a19]">Requiert l'attention :</span> Amani Yann <span class="font-extralight">(vous)</span></p>
                                </div>
                                <div class="pl-[41px] mt-[4px]">
                                    <textarea name="comment" class="h-[100px] w-full p-6 rounded-xl border font-light" placeholder="Ecrire le commentaire"></textarea>
                                    <div class="flex flex-col items-center mt-[8px]">
                                        <p class="font-extralight">Vous êtes assigé(e) à la validation de cette requête</p>
                                        <div class="flex w-full mt-[8px] font-light justify-between">
                                            <button class="h-[35px] rounded border w-[49%]">Refuser</button>
                                            <button class="h-[35px] text-white rounded border w-[49%] bg-[#0c5ccf]">Valider</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="h-[8px]"/>
                    </div>
                </div>
            </DialogContent>
        </DialogPortal>
    </DialogRoot>
</template>
<script>
import {
  DialogContent,
  DialogOverlay,
  DialogPortal,
  DialogRoot,
  DialogClose,
  DialogTrigger,
} from 'radix-vue';
import { advancedFormat, convertirDateEnFrancais } from '@/utils/date-format';
import { X,Plus,Check,Info,Loader } from "lucide-vue-next";
export default {
    name: "ValidationDetail",
    components: {
        DialogContent,
        DialogOverlay,
        DialogPortal,
        DialogRoot,
        DialogClose,
        DialogTrigger,
        X,Plus,Check,Info,Loader
    },
    props:['request'],
    data(){
        return {}
    },
    methods: {
        formatDate(date){return convertirDateEnFrancais(date)},
        formatDate2(date){
            const [date1,date2] = date.split('T');
            return advancedFormat(date1,date2);
        },
    }
}
</script>